<template>
  <div class="grid-search-guide">
    <div style="height: 88px"></div>
    <div class="left-panel" style="width: 272px; top: 88px;float: left;"></div>
    <div class="main guide-main">
      <div style="padding: 16px;">
      <div class="search-form-box main-card whaty-grid-search-form search-fold-part">
        <div class="mSearch-form-group">
          <ul class="clearfix">
            <li ref="step1" class="search-cell">
              <div class="form-row">
                <div class="form-con">
                  <div class="input-wrap">
                    <input name="form-name" type="text" class="form-control" value="" placeholder="文本型">
                  </div>
                </div>
              </div>
            </li>
            <li ref="step2" class="search-cell">
              <div class="form-row">
                <div class="form-con">
                  <div class="input-wrap">
                    <input name="form-name" type="text" class="form-control" value="" placeholder="数值型">
                  </div>
                </div>
              </div>
            </li>
            <li ref="step3" class="search-cell">
              <div class="form-row">
                <div class="form-con">
                  <div class="input-wrap input-hasappend input-hasicon">
                    <span class="input-icon"><i class="mng icon-calendar-stroke"></i></span>
                    <input name="form-name" type="text" class="form-control" value="" placeholder="日期型">
                    <div class="input-append select-icon"><a data-role="select" class="btn btn-icon"><i class="mng icon-arrow-down-fill"></i></a></div>
                  </div>
                </div>
              </div>
            </li>
            <li ref="step4" class="search-cell">
              <div class="form-row">
                <div class="form-con">
                  <div class="input-wrap input-hasappend">
                    <input name="form-name" type="text" class="form-control" value="" placeholder="下拉型">
                    <div class="input-append select-icon"><a data-role="select" class="btn btn-icon"><i class="mng icon-arrow-down-fill"></i></a></div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="search-submit-area">
          <div ref="step5" class="guide-btn">
            <a href="javascript:"><i class="mng icon-question-stroke"></i><span>搜索引导</span></a>
          </div>
          <a href="javascript:" class="btn btn-anti-primary">保存搜索条件</a>
          <div class="mSearch-filter">
            <el-select
              placeholder="我的查询" size="mini" filterable clearable popper-class="search-select drop-form" value>
            </el-select>
          </div>
          <a href="javascript:" ondragstart="return false" class="btn btn-solid-primary">搜索</a>
          <a href="javascript:" ondragstart="return false" class="btn btn-anti-default">重置</a>
        </div>
        <div class="search-fold-foot">
          <div class="el-dropdown">
            <a href="javascript:;" class="search-fold-btn el-dropdown-link el-dropdown-selfdefine"><i class="mng icon-fold-down"></i></a>
          </div>
        </div>
      </div>
      <div class="main-table-box main-card">
        <div class="mOperation-wrap">
          <ul class="clearfix">
              <span>
                <a href="javascript:" ondragstart="return false" class="btn btn-hollow-primary btn-icon">
                  <i class="mng icon-icon-test-copy"></i><span>添加</span></a>
                <a href="javascript:" ondragstart="return false" class="btn btn-hollow-dark btn-icon">
                  <i class="mng icon-batchimport-stroke1"></i><span>导入</span></a>
              </span>
            <li class="pull-right">
              <div class="pull-right-item"><a href="javascript:" ondragstart="return false" class="btn btn-anti-primary">保存视图</a></div>
              <div class="pull-right-item"><a href="javascript:" class="el-tooltip btn btn-hollow-dark btn-icon-only item"><i class="mng icon-refresh-fold"></i></a></div>
              <div class="pull-right-item"><a href="javascript:" class="el-tooltip btn btn-hollow-dark btn-icon-only item"><i class="mng icon-field-stroke1"></i></a></div>
              <div class="pull-right-item"><a href="javascript:" class="el-tooltip btn btn-hollow-dark btn-icon-only item"><i class="mng icon-freeze-stroke1"></i></a></div>
            </li>
            </ul>
        </div>
        <div class="main-table" :style="{height: tBodyHeight + 'px'}">
              <!--------------------
              // table head
              -------------------->
              <div class="main-table-head">
                <ul class="main-table-head-wrap clearfix">
                  <!-- firstTD -->
                  <li class="main-table-cell main-table-cell-first" style="left: 0px;">
                    <div class="main-table-cell-wrap checkbox-wrap">
                      <label class="form-label">
                        <span class="form-checkbox-btn"><i class="mng icon-tick-stroke"></i></span>
                        <input type="checkbox">
                      </label>
                    </div>
                  </li>
                  <!-- firstTD end -->
                  <li class="main-table-cell main-table-cell-medium">
                    <div class="main-table-cell-wrap">
                      <span class="main-table-txt">学号
                        <span class="main-table-sort"><i class="mng icon-descending"></i></span>
                      </span>
                    </div>
                  </li>
                  <li class="main-table-cell main-table-cell-base">
                    <div class="main-table-cell-wrap">
                      <span class="main-table-txt">姓名
                        <span class="main-table-sort"><i class="mng icon-descending"></i></span>
                      </span>
                    </div>
                  </li>
                  <li class="main-table-cell main-table-cell-base">
                    <div class="main-table-cell-wrap">
                      <span class="main-table-txt">年级
                        <span class="main-table-sort"><i class="mng icon-descending"></i></span>
                      </span>
                    </div>
                  </li>
                  <li class="main-table-cell main-table-cell-medium">
                    <div class="main-table-cell-wrap">
                      <span class="main-table-txt">教学点
                        <span class="main-table-sort"><i class="mng icon-descending"></i></span>
                      </span>
                    </div>
                  </li>
                  <li class="main-table-cell main-table-cell-medium">
                    <div class="main-table-cell-wrap">
                      <span class="main-table-txt">专业
                        <span class="main-table-sort"><i class="mng icon-descending"></i></span>
                      </span>
                    </div>
                  </li>
                  <li class="main-table-cell main-table-cell-base">
                    <div class="main-table-cell-wrap">
                      <span class="main-table-txt">层次
                        <span class="main-table-sort"><i class="mng icon-descending"></i></span>
                      </span>
                    </div>
                  </li>
                  <li class="main-table-cell main-table-cell-medium">
                    <div class="main-table-cell-wrap">
                      <span class="main-table-txt">课程名称
                        <span class="main-table-sort"><i class="mng icon-descending"></i></span>
                      </span>
                    </div>
                  </li>
                  <li class="main-table-cell main-table-cell-base">
                    <div class="main-table-cell-wrap">
                      <span class="main-table-txt">学习形式
                        <span class="main-table-sort"><i class="mng icon-descending"></i></span>
                      </span>
                    </div>
                  </li>
                  <li class="main-table-cell main-table-cell-base">
                    <div class="main-table-cell-wrap">
                      <span class="main-table-txt">考试成绩
                        <span class="main-table-sort"><i class="mng icon-descending"></i></span>
                      </span>
                    </div>
                  </li>
                </ul>
              </div>
              <!--------------------
              // table head
              -------------------->

              <!--------------------
              // table body
              -------------------->
              <div class="main-table-body">
                <el-scrollbar ref="elScorller" class="whaty-scroll mTable-body myTableBody" wrap-class="whaty-scroll-wrap el-scrollbar__wrap--hidden-default"
                              :style="{height: tBodyHeight - 31 + 'px'}">
                    <ul>
                      <li class="main-table-row">
                        <ul class="main-table-row-wrap clearfix">
                          <!-- firstTD -->
                          <li class="main-table-cell main-table-cell-first" style="left: 0px;">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-num">1</span>
                              <label class="form-label">
                                <span class="form-checkbox-btn"><i class="mng icon-tick-stroke"></i></span>
                                <input type="checkbox">
                              </label>
                            </div>
                          </li>
                          <!-- firstTD end -->
                          <li class="main-table-cell main-table-cell-medium">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">16013402001</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-base">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">宋萌</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-base">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">2016级</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-medium">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">保定校部</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-medium">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">市场营销</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-base">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">高起专</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-medium">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">大学计算机基础</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-base">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">业余</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-base">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">89.0</span>
                            </div>
                          </li>
                        </ul>
                      </li>
                      <li class="main-table-row main-table-row-even">
                        <ul class="main-table-row-wrap clearfix">
                          <!-- firstTD -->
                          <li class="main-table-cell main-table-cell-first" style="left: 0px;">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-num">2</span>
                              <label class="form-label">
                                <span class="form-checkbox-btn"><i class="mng icon-tick-stroke"></i></span>
                                <input type="checkbox">
                              </label>
                            </div>
                          </li>
                          <!-- firstTD end -->
                          <li class="main-table-cell main-table-cell-medium">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">16013402001</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-base">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">宋萌</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-base">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">2016级</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-medium">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">保定校部</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-medium">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">市场营销</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-base">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">高起专</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-medium">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">大学计算机基础</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-base">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">业余</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-base">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">89.0</span>
                            </div>
                          </li>
                        </ul>
                      </li>
                      <li class="main-table-row">
                        <ul class="main-table-row-wrap clearfix">
                          <!-- firstTD -->
                          <li class="main-table-cell main-table-cell-first" style="left: 0px;">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-num">3</span>
                              <label class="form-label">
                                <span class="form-checkbox-btn"><i class="mng icon-tick-stroke"></i></span>
                                <input type="checkbox">
                              </label>
                            </div>
                          </li>
                          <!-- firstTD end -->
                          <li class="main-table-cell main-table-cell-medium">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">16013402001</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-base">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">宋萌</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-base">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">2016级</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-medium">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">保定校部</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-medium">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">市场营销</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-base">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">高起专</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-medium">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">大学计算机基础</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-base">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">业余</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-base">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">89.0</span>
                            </div>
                          </li>
                        </ul>
                      </li>
                      <li class="main-table-row main-table-row-even">
                        <ul class="main-table-row-wrap clearfix">
                          <!-- firstTD -->
                          <li class="main-table-cell main-table-cell-first" style="left: 0px;">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-num">4</span>
                              <label class="form-label">
                                <span class="form-checkbox-btn"><i class="mng icon-tick-stroke"></i></span>
                                <input type="checkbox">
                              </label>
                            </div>
                          </li>
                          <!-- firstTD end -->
                          <li class="main-table-cell main-table-cell-medium">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">16013402001</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-base">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">宋萌</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-base">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">2016级</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-medium">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">保定校部</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-medium">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">市场营销</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-base">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">高起专</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-medium">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">大学计算机基础</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-base">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">业余</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-base">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">89.0</span>
                            </div>
                          </li>
                        </ul>
                      </li>
                      <li class="main-table-row">
                        <ul class="main-table-row-wrap clearfix">
                          <!-- firstTD -->
                          <li class="main-table-cell main-table-cell-first" style="left: 0px;">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-num">5</span>
                              <label class="form-label">
                                <span class="form-checkbox-btn"><i class="mng icon-tick-stroke"></i></span>
                                <input type="checkbox">
                              </label>
                            </div>
                          </li>
                          <!-- firstTD end -->
                          <li class="main-table-cell main-table-cell-medium">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">16013402001</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-base">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">宋萌</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-base">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">2016级</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-medium">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">保定校部</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-medium">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">市场营销</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-base">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">高起专</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-medium">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">大学计算机基础</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-base">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">业余</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-base">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">89.0</span>
                            </div>
                          </li>
                        </ul>
                      </li>
                      <li class="main-table-row main-table-row-even">
                        <ul class="main-table-row-wrap clearfix">
                          <!-- firstTD -->
                          <li class="main-table-cell main-table-cell-first" style="left: 0px;">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-num">6</span>
                              <label class="form-label">
                                <span class="form-checkbox-btn"><i class="mng icon-tick-stroke"></i></span>
                                <input type="checkbox">
                              </label>
                            </div>
                          </li>
                          <!-- firstTD end -->
                          <li class="main-table-cell main-table-cell-medium">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">16013402001</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-base">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">宋萌</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-base">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">2016级</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-medium">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">保定校部</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-medium">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">市场营销</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-base">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">高起专</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-medium">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">大学计算机基础</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-base">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">业余</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-base">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">89.0</span>
                            </div>
                          </li>
                        </ul>
                      </li>
                      <li class="main-table-row">
                        <ul class="main-table-row-wrap clearfix">
                          <!-- firstTD -->
                          <li class="main-table-cell main-table-cell-first" style="left: 0px;">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-num">7</span>
                              <label class="form-label">
                                <span class="form-checkbox-btn"><i class="mng icon-tick-stroke"></i></span>
                                <input type="checkbox">
                              </label>
                            </div>
                          </li>
                          <!-- firstTD end -->
                          <li class="main-table-cell main-table-cell-medium">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">16013402001</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-base">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">宋萌</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-base">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">2016级</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-medium">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">保定校部</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-medium">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">市场营销</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-base">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">高起专</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-medium">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">大学计算机基础</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-base">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">业余</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-base">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">89.0</span>
                            </div>
                          </li>
                        </ul>
                      </li>
                      <li class="main-table-row main-table-row-even">
                        <ul class="main-table-row-wrap clearfix">
                          <!-- firstTD -->
                          <li class="main-table-cell main-table-cell-first" style="left: 0px;">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-num">8</span>
                              <label class="form-label">
                                <span class="form-checkbox-btn"><i class="mng icon-tick-stroke"></i></span>
                                <input type="checkbox">
                              </label>
                            </div>
                          </li>
                          <!-- firstTD end -->
                          <li class="main-table-cell main-table-cell-medium">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">16013402001</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-base">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">宋萌</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-base">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">2016级</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-medium">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">保定校部</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-medium">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">市场营销</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-base">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">高起专</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-medium">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">大学计算机基础</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-base">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">业余</span>
                            </div>
                          </li>
                          <li class="main-table-cell main-table-cell-base">
                            <div class="main-table-cell-wrap">
                              <span class="main-table-txt">89.0</span>
                            </div>
                          </li>
                        </ul>
                      </li>
                    </ul>
                </el-scrollbar>
                  </div>
              <!--------------------
              // table body end
              -------------------->
            </div>
      </div>
      <div class="footer" style="left: 272px">
        <div class="footer-left">
          <a href="javascript:;" class="btn btn-hollow-dark btn-icon-only footer-btn-icon"><i class="mng icon-share-stroke"></i></a>
          <a href="javascript:;" class="btn btn-hollow-dark btn-icon-only footer-btn-icon"><i class="mng icon-time-stroke"></i></a>
        </div>
        <div class="pagination-wrapper pagination-circle pagination-hover-solid text-center">
          <div class="el-pagination">
            <button type="button" disabled="disabled" class="btn-prev"><i class="el-icon el-icon-arrow-left"></i>
            </button>
            <ul class="el-pager">
              <li class="number active">1</li>
            </ul>
            <button type="button" disabled="disabled" class="btn-next"><i class="el-icon el-icon-arrow-right"></i>
            </button>
          </div>
          <div class="pg-input"><span class="text">前往</span><span><input type="number" class="form-control"></span><span class="text">页</span></div>
        </div>
        <div class="footer-right">
          <div class="pagination-wrapper pagination-circle pagination-hover-solid">
            <div class="pg-total"><span class="text">共</span><span class="num">1</span><span class="text">页</span></div>
            <div class="pg-total"><span class="text">共</span><span class="num">8</span><span class="text">条</span></div>
            <div class="pg-select-wrap">
              <div class="pg-select"><i class="mng pg-select-arr icon-lineArrD-stroke"></i>
                <div class="pg-select-result">显示20条</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    <div class="guide-container">
      <!--- guide 1 --->
      <div class="guide-wrap" :style="guideStyle">
        <div :style="stepData[step - 1].guideFocusStyle"></div>
        <div :class="{'guide-point-bottom': stepData[step - 1].position === 'bottom',
                      'guide-point-left': stepData[step - 1].position === 'left',
                      'guide-point-right': stepData[step - 1].position === 'right'}">
        </div>
        <div :class="{'guide-box-bottom': stepData[step - 1].position === 'bottom',
                      'guide-box-left': stepData[step - 1].position === 'left',
                      'guide-box-right': stepData[step - 1].position === 'right'}">
          <div class="box-body">
            <div class="title">
              <span class="icon"></span>
              <span class="text" v-html="stepData[step - 1].title"></span>
            </div>
            <div class="con">
              <div v-html="stepData[step - 1].descriptionHtml"></div>
            </div>
          </div>
          <div class="box-foot">
            <div class="guide-nav">
              <span v-for="item of totalStep" :class="{'active' : step === item}" @click="stepChange(item)"></span>
            </div>
            <span class="text">（{{ step }}/{{ totalStep }}）</span>
            <a v-if="step < totalStep" href="javascript:;" class="link-default jump-link mr10" @click.prevent="quitGuide">跳过全部</a>
            <a v-if="step < totalStep" href="javascript:;" class="btn btn-solid-primary" @click.prevent="stepChange(step + 1)">下一步</a>
            <a v-if="step === totalStep" href="javascript:;" class="link-default jump-link mr10" @click.prevent="stepChange(1)">再看一遍</a>
            <a v-if="step === totalStep" href="javascript:;" class="btn btn-solid-primary" @click.prevent="quitGuide">知道啦</a>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import util from '../../libs/util'
import {addResizeListener, removeResizeListener} from 'element-ui/src/utils/resize-event'

export default {
  name: 'grid-search-guide',
  props: {
    gridConfigUrl: {
      type: String,
      default: ''
    },
    searchGuideState: {
      type: Number,
      default: 0
    }
  },
  data() {
    let theme = localStorage.getItem('theme') != null ? localStorage.getItem('theme') : 'main-blue'// 获取主题
    return {
      stepData: [
        {
          refName: 'step1', // 定位ref名称
          title: '文本型输入框',  // 提示框名称
          position: 'right',  // 提示框位置
          guideFocusStyle: {
            'width': '324px',
            'height': '215px',
            'background-image': 'url(/static/styles/images/grid-search-guide/' + theme + '/guide-1.png)',
            'padding': '17px 4px 0 4px',
            'background-repeat': 'no-repeat',
            'background-position': 'center 13px',
            'border': '2px dashed white',
            'border-radius': '20px',
            '-webkit-border-radius': '20px',
            '-moz-border-radius': '20px',
            '-ms-border-radius': '20px',
            '-o-border-radius': '20px'
          },
          descriptionHtml: '<p><b class="num">1.</b>单击唤起高级搜索</p>' +
            '<p><b class="num">2.</b>通过“已填写”和“未填写”对空值和非空值进行检索</p>'
        },
        {
          refName: 'step1',
          title: '文本型输入框',
          position: 'right',
          guideFocusStyle: {
            'width': '232px',
            'height': '175px',
            'background-image': 'url(/static/styles/images/grid-search-guide/' + theme + '/guide-2.png)',
            'padding': '17px 4px 0 4px',
            'background-repeat': 'no-repeat',
            'background-position': 'center 13px',
            'border': '2px dashed white',
            'border-radius': '20px',
            '-webkit-border-radius': '20px',
            '-moz-border-radius': '20px',
            '-ms-border-radius': '20px',
            '-o-border-radius': '20px'
          },
          descriptionHtml: '<p><b class="num">1.</b>输入检索内容后点击<i class="mng icon-nav-fun-stroke icon"></i>选择搜索模式</p>' +
            '<p><b class="num">2.</b>只要包含关键词为模糊匹配，默认为模糊匹配</p>' +
            '<p><b class="num">3.</b>等于关键词即只检索和关键词完全一致的数据</p>' +
            '<p><b class="num">4.</b>高级操作：使用"="进行精准匹配</p>'
        },
        {
          refName: 'step2',
          title: '数值型检索框',
          position: 'left',
          guideFocusStyle: {
            'width': '324px',
            'height': '263px',
            'background-image': 'url(/static/styles/images/grid-search-guide/' + theme + '/guide-3.png)',
            'padding': '17px 4px 0 4px',
            'background-repeat': 'no-repeat',
            'background-position': 'center 13px',
            'border': '2px dashed white',
            'border-radius': '20px',
            '-webkit-border-radius': '20px',
            '-moz-border-radius': '20px',
            '-ms-border-radius': '20px',
            '-o-border-radius': '20px'
          },
          descriptionHtml: '<p><b class="num">1.</b>支持区间检索，左侧表示≥输入值，右侧表示≤输入值</p>' +
            '<p><b class="num">2.</b>两侧均为闭区间</p>' +
            '<p><b class="num">3.</b>支持空值和非空值的检索</p>' +
            '<p><b class="num">4.</b>高级操作：使用“≥”或“≤”也可以检索对应数据</p>'
        },
        {
          refName: 'step3',
          title: '时间型检索框',
          position: 'left',
          guideFocusStyle: {
            'width': '232px',
            'height': '443px',
            'background-image': 'url("/static/styles/images/grid-search-guide/' + theme + '/guide-4.png")',
            'padding': '17px 4px 0 4px',
            'background-repeat': 'no-repeat',
            'background-position': 'center 13px',
            'border': '2px dashed white',
            'border-radius': '20px',
            '-webkit-border-radius': '20px',
            '-moz-border-radius': '20px',
            '-ms-border-radius': '20px',
            '-o-border-radius': '20px'
          },
          descriptionHtml: '<p><b class="num">1.</b>点击检索框出现高级搜索</p>' +
            '<p><b class="num">2.</b>可选择范围时间检索</p>' +
            '<p><b class="num">3.</b>支持对“已填写”和“未填写”内容进行检索</p>'
        },
        {
          refName: 'step3',
          title: '时间型检索框',
          position: 'left',
          guideFocusStyle: {
            'width': '603px',
            'height': '472px',
            'background-image': 'url("/static/styles/images/grid-search-guide/' + theme + '/guide-5-2.gif")',
            'padding': '17px 4px 0 4px',
            'background-repeat': 'no-repeat',
            'background-position': 'center 14px',
            'border': '2px dashed white',
            'border-radius': '20px',
            '-webkit-border-radius': '20px',
            '-moz-border-radius': '20px',
            '-ms-border-radius': '20px',
            '-o-border-radius': '20px'
          },
          descriptionHtml: '<p><b class="num">1.</b>点击选择时间可选择具体的时间</p>' +
            '<p><b class="num">2.</b>点击年份可以下拉进行选择</p>' +
            '<p><b class="num">3.</b>点击确认，将选好的时间填充到输入框</p>'
        },
        {
          refName: 'step4',
          title: '下拉型检索框',
          position: 'left',
          guideFocusStyle: {
            'width': '232px',
            'height': '488px',
            'background-image': 'url("/static/styles/images/grid-search-guide/' + theme + '/guide-5.png")',
            'padding': '17px 4px 0 4px',
            'background-repeat': 'no-repeat',
            'background-position': 'center 13px',
            'border': '2px dashed white',
            'border-radius': '20px',
            '-webkit-border-radius': '20px',
            '-moz-border-radius': '20px',
            '-ms-border-radius': '20px',
            '-o-border-radius': '20px'
          },
          descriptionHtml: '<p><b class="num">1.</b>下拉框支持多选、快速全选</p>' +
            '<p><b class="num">2.</b>选择后悬停于下拉框显示选择数量</p>' +
            '<p><b class="num">3.</b>下拉框中支持搜索，支持拼音和首字母匹配</p>'
        },
        {
          refName: 'step5',
          title: '点击' + '<img src="/static/styles/images/grid-search-guide/' + theme + '/guide-7.png">' + '再看一遍',
          position: 'bottom',
          guideFocusStyle: {
            'padding': '10px',
            'width': '100px',
            'height': '30px',
            'background-image': 'url("/static/styles/images/grid-search-guide/' + theme + '/guide-7.png")',
            'background-repeat': 'no-repeat',
            'background-position': 'center',
            'border': '2px dashed white',
            'border-radius': '20px',
            '-webkit-border-radius': '20px',
            '-moz-border-radius': '20px',
            '-ms-border-radius': '20px',
            '-o-border-radius': '20px'
          },
          descriptionHtml: ''
        }
      ],
      totalStep: '', // 总步数
      step: 1,  // 当前步数
      guideStyle: {}, // guide样式
      tBodyHeight: 200
    }
  },
  mounted() {
    this.totalStep = this.stepData.length
    this.stepChange(1)
    addResizeListener(this.$el, this.computeHeight)
  },
  beforeDestroy() {
    removeResizeListener(this.$el, this.computeHeight)
  },
  computed: {
    saveOrUpdateSearchGuideState: function () {
      return this.gridConfigUrl.replace('abstractGrid', 'saveOrUpdateSearchGuideState')
    }
  },
  methods: {
    stepChange(step) {
      this.step = step
      let boundingClientRect = {}
      // 数组角标从0开始比真实步数少1
      let stepDatum = this.stepData[step - 1]
      let refName = stepDatum.refName
      // 获取定位
      boundingClientRect = this.$refs[refName].getBoundingClientRect()
      this.guideStyle = {
        'top': boundingClientRect.top - 11 + 'px',
        'left': boundingClientRect.left - 10 + 'px'
      }
    },
    quitGuide() {
      // 如果是已经查询过的则不用调用更新接口
      if (this.searchGuideState === 1) {
        this.$emit('grid-search-guide-flag', false)
        return
      }
      let params = {
        params: {
          searchGuideState: 1
        }
      }
      util.ajax.post(this.saveOrUpdateSearchGuideState, params).then((res) => {
        if (res.data.meta.errCode === 0) {
          this.$emit('grid-search-guide-flag', false)
        }
      }).catch((err) => {
        console.error(err)
        this.$notify.error({title: '错误', message: '操作失败'})
        this.gridSearchGuide = false
      })
    },
    computeHeight() { // 计算高度
      this.tBodyHeight = this.$el.offsetHeight - 420
    }
  }
}
</script>
<style src="./index.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/components/grid-search-guide/index.vue